var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"aaee93abe8a62306734aadca909495bac8d6766c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["pastel-frontend@usepastel"]={id:"aaee93abe8a62306734aadca909495bac8d6766c"};
      